import { render } from "./WatchlistsView.vue?vue&type=template&id=e3a5c87a&scoped=true"
import script from "./WatchlistsView.vue?vue&type=script&lang=js"
export * from "./WatchlistsView.vue?vue&type=script&lang=js"

import "./WatchlistsView.vue?vue&type=style&index=0&id=e3a5c87a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3a5c87a"]])

export default __exports__